var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "graphic-content" } },
    [
      JSON.stringify(_vm.detail) === "{}"
        ? [_vm._m(0)]
        : [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "content-box-card",
              },
              [
                _c("div", { staticClass: "content-box-card-title" }, [
                  _c("div", { staticClass: "left" }, [
                    _c("label", [_vm._v(_vm._s(_vm.detail.name))]),
                    _vm.detail.status === 1
                      ? _c("span", { staticClass: "runing" }, [
                          _vm._v("正常运行"),
                        ])
                      : _c("span", { staticClass: "suspend" }, [
                          _vm._v("已暂停"),
                        ]),
                  ]),
                  _c("div", { staticClass: "right" }, [
                    _c("span", [
                      _vm._v(
                        "更新方式：" +
                          _vm._s(_vm.detail.updateWayLabel) +
                          "更新"
                      ),
                    ]),
                    _vm.rQuery.labelId
                      ? _c("span", [
                          _vm._v(
                            "创建方式：" +
                              _vm._s(_vm.detail.createWayLabel || "-")
                          ),
                        ])
                      : _vm._e(),
                    _c("span", [
                      _vm._v(
                        "创建人：" +
                          _vm._s(
                            _vm.detail.createByName
                              ? _vm.detail.createByName
                              : "-"
                          )
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "content-box-card-info" }, [
                  _c("div", { staticClass: "text-info" }, [
                    _vm._v(_vm._s(_vm.detail.remark || "-")),
                  ]),
                  _c(
                    "div",
                    { staticClass: "text-info font14" },
                    [
                      _vm._v(
                        "通过" +
                          _vm._s(_vm.detail.createWayLabel) +
                          "规则，将客户划分为" +
                          _vm._s(_vm.detail.tierNameList.length) +
                          "层，分别为："
                      ),
                      _vm._l(_vm.detail.tierNameList, function (it) {
                        return _c("span", [_vm._v(_vm._s(it))])
                      }),
                      _vm._v("... "),
                      _vm.rQuery.labelId || _vm.rQuery.type === "label"
                        ? _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  path: "/LabelGroup/labelAdd",
                                  query: {
                                    type:
                                      _vm.detail.createWay == 1
                                        ? "program"
                                        : "diy",
                                    labelId: _vm.detail.id,
                                    createWay: _vm.detail.createWay,
                                  },
                                },
                              },
                            },
                            [_vm._v("查看详情>>")]
                          )
                        : _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  path: "/LabelGroup/labelAdd",
                                  query: {
                                    type: "group",
                                    groupId: _vm.detail.id,
                                    createWay: _vm.detail.createWay,
                                  },
                                },
                              },
                            },
                            [_vm._v("查看详情>>")]
                          ),
                      _c(
                        "div",
                        { staticClass: "button-list" },
                        [
                          _vm.detail.createWay === 1
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "small",
                                    loading: _vm.upDataLoading,
                                  },
                                  on: { click: () => _vm.onUpData() },
                                },
                                [_vm._v("更新")]
                              )
                            : _vm._e(),
                          _vm.rQuery.groupId
                            ? _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      path: "/LabelGroup/labelChangeRecord",
                                      query: {
                                        groupId: _vm.detail.id,
                                        pageTitle: 1,
                                      },
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { size: "small" } },
                                    [_vm._v("变更记录")]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      path: "/LabelGroup/labelChangeRecord",
                                      query: {
                                        labelId: _vm.detail.id,
                                        pageTitle: 2,
                                      },
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { size: "small" } },
                                    [_vm._v("变更记录")]
                                  ),
                                ],
                                1
                              ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                loading: _vm.exportLoading,
                              },
                              on: {
                                click: () => _vm.onSelectEmployeeKpiExport(),
                              },
                            },
                            [_vm._v("导出")]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingEcharts,
                    expression: "loadingEcharts",
                  },
                ],
                staticClass: "content-box-card",
              },
              [
                _c("div", { staticClass: "content-box-card-title" }, [
                  _c("div", { staticClass: "left" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.rQuery.labelId ? "标签" : "分群") +
                          "人数分布"
                      ),
                    ]),
                  ]),
                ]),
                _vm.echartsPieColumnar.dataList.length <= 0
                  ? [_vm._m(1)]
                  : [
                      _c(
                        "el-tabs",
                        {
                          staticClass: "distribution",
                          attrs: { tabPosition: "left" },
                          on: { "tab-click": _vm.changeTabs },
                          model: {
                            value: _vm.tabsActiveName,
                            callback: function ($$v) {
                              _vm.tabsActiveName = $$v
                            },
                            expression: "tabsActiveName",
                          },
                        },
                        [
                          _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: "饼状图",
                                name: "pie",
                                lazy: true,
                              },
                            },
                            [
                              _vm.tabsActiveName === "pie"
                                ? _c(
                                    "div",
                                    { staticClass: "echarts-box" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "echarts-box-info" },
                                        [
                                          _c("div", [
                                            _c("span", [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.echartsPieColumnar
                                                      .totalPeopleNum
                                                  )
                                                ),
                                              ]),
                                              _vm._v("人"),
                                            ]),
                                            _vm._v("（在全部客户中占比："),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.echartsPieColumnar
                                                    .totalPeopleNumRate
                                                ) + "%"
                                              ),
                                            ]),
                                            _vm._v("）"),
                                          ]),
                                          _c("div", { staticClass: "font14" }, [
                                            _vm._v(
                                              "开始时间 " +
                                                _vm._s(
                                                  _vm.echartsPieColumnar
                                                    .createdTime
                                                ) +
                                                "，计算完成时间 " +
                                                _vm._s(
                                                  _vm.echartsPieColumnar
                                                    .updatedTime || "-"
                                                )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c("echarts-pie", {
                                        directives: [
                                          {
                                            name: "loading",
                                            rawName: "v-loading",
                                            value:
                                              _vm.echartsPieColumnar.loading,
                                            expression:
                                              "echartsPieColumnar.loading",
                                          },
                                        ],
                                        attrs: {
                                          documentId: "money",
                                          config: _vm.echartsPieColumnar.config,
                                          dataList:
                                            _vm.echartsPieColumnar.dataList,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: "柱状图",
                                name: "columnar",
                                lazy: true,
                              },
                            },
                            [
                              _vm.tabsActiveName === "columnar"
                                ? _c("div", { staticClass: "echarts-box" }, [
                                    _c(
                                      "div",
                                      { staticClass: "echarts-box-info" },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.echartsPieColumnar
                                                    .totalPeopleNum
                                                )
                                              ),
                                            ]),
                                            _vm._v("人"),
                                          ]),
                                          _vm._v("（在全部客户中占比："),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.echartsPieColumnar
                                                  .totalPeopleNumRate
                                              ) + "%"
                                            ),
                                          ]),
                                          _vm._v("）"),
                                        ]),
                                        _c("div", { staticClass: "font14" }, [
                                          _vm._v(
                                            "开始时间 " +
                                              _vm._s(
                                                _vm.echartsPieColumnar
                                                  .createdTime
                                              ) +
                                              "，计算完成时间 " +
                                              _vm._s(
                                                _vm.echartsPieColumnar
                                                  .updatedTime || "-"
                                              )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { attrs: { id: "echarts-columnar" } },
                                      [
                                        _c("echarts-columnar", {
                                          directives: [
                                            {
                                              name: "loading",
                                              rawName: "v-loading",
                                              value:
                                                _vm.echartsPieColumnar.loading,
                                              expression:
                                                "echartsPieColumnar.loading",
                                            },
                                          ],
                                          attrs: {
                                            documentId: "echarts-columnar",
                                            config:
                                              _vm.echartsPieColumnar.config,
                                            dataList:
                                              _vm.echartsPieColumnar.dataList,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", {
        attrs: { src: require("@/assets/EmptyState/noContent.png") },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", {
        attrs: { src: require("@/assets/EmptyState/noContent.png") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }